import Column from '@components/Column';
import Row from '@components/Row';
import Skeleton from '@components/Skeleton';

function GiftBoxItemSkeletons({ count = 5 }: { count?: number }) {
    return (
        <Column fullWidth spacing={6} aria-busy>
            {Array.from({ length: count }, (_, index) => (
                <Row key={index} fullWidth align='center' spacing={4}>
                    <Skeleton shape='block' width={100} height={100} />
                    <Column fullWidth spacing={2}>
                        <Skeleton width='30%' height={20} />
                        <Skeleton width='70%' height={22} />
                        <Skeleton width='50%' height={20} />
                    </Column>
                </Row>
            ))}
        </Column>
    );
}

export default GiftBoxItemSkeletons;
